<template>
  <gift-handover-gate page="gifts" title="贈品管理">
    <section>
      <section class="pb-4" style="display: block;">
        <gift-list :query="query" @selected="onSelected" @updated="onRefresh" />
      </section>
      <section class="box" style="margin-top: 5px;">
        <gift-post-list ref="list" :gifts="selectedGifts" />
      </section>
    </section>
  </gift-handover-gate>
</template>

<script>
import GiftHandoverGate from '@/components/gifts/GiftHandoverGate'
import GiftList from '@/components/gifts/GiftList'
import GiftPostList from '@/components/gifts/GiftPostList'

export default {
  name: 'Gifts',
  components: { GiftHandoverGate, GiftList, GiftPostList },

  data() {
    const { query } = this.$route

    return {
      query: query,
      selectedGifts: [],

      loadingGift: false
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  },
  methods: {
    onSelected(items) {
      this.selectedGifts = items
    },
    async onRefresh() {
      await this.$refs.list.refresh()
    }
  }
}
</script>
